<template lang="pug">
  .footer
    .container
      .row
        .col-12
          .footer__cp
            span.footer__team Подготовлено &nbsp;
            a(href='https://pink-man.ru/' target='_blank').footer__pinkman
              include ../assets/img/pinkman.svg
</template>
<script>
export default {
  name: 'FooterItem'
}
</script>
<style lang="stylus" scoped>
.footer

  .container
    padding-top 2rem
    padding-bottom 2rem
  &__cp
    display flex
    align-items flex-end
    justify-content flex-end
    flex-flow: row wrap
    font-weight 600
    font-size 1.2rem
    line-height 1
    color: rgba($black, 0.2)
    letter-spacing: -0.17px
    @media $tablet
      font-size: 1.4rem
  svg
    width 7.5rem
    height 1.2rem
    color rgba($black, 0.2)
    transition color 0.3s ease
    margin: 0 0.5rem
    &:hover
      color $pink
    @media $tablet
      width 8.7rem
      height 1.3rem

</style>
